import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

//
import IMG from "../../../assets/images/all-service-faq.jpg";
import FaqCard from "../../../components/faq-card/FaqCard";

//
const FAQLIST = [
  {
    id: uuidv4(),
    title: "allServiceFaqQuestion1",
    text: "allServiceFaqAnswer1",
  },
  {
    id: uuidv4(),
    title: "allServiceFaqQuestion2",
    text: "allServiceFaqAnswer2",
  },
  {
    id: uuidv4(),
    title: "allServiceFaqQuestion3",
    text: "allServiceFaqAnswer3",
  },
];

export default function AllServiceFaq() {
  const { t } = useTranslation();

  return (
    <StyledAllServiceFaq>
      <div className="container">
        <div className="all-service-faq__wrap">
          <div className="all-service-faq__left">
            <div className="all-service-faq__img">
              <img src={IMG} alt="IMG" />
            </div>
          </div>
          <div className="all-service-faq__right">
            <h1
              dangerouslySetInnerHTML={{ __html: t("allServiceFaqTitle") }}
            ></h1>
            <ul>
              {FAQLIST.map((i) => (
                <li key={i.id}>
                  <FaqCard title={i.title} text={i.text} />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </StyledAllServiceFaq>
  );
}

const StyledAllServiceFaq = styled.section`
  padding-bottom: 140px;

  .all-service-faq {
    &__wrap {
      display: grid;
      grid-template-columns: 500px auto;
      gap: 72px;
    }

    &__img {
      width: 500px;
      height: 500px;
      border: 1px solid var(--border);
      line-height: 0;
      overflow: hidden;
      border-radius: 50%;

      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }

    &__right {
      & > h1 {
        color: var(--title);
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: 40px;

        span {
          color: var(--light-blue);
        }
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 40px;
      }
    }
  }
`;
